import { parseQuickLinks } from '../lib/quick-links';
import type { QuickLinksConfig } from '../lib/quick-links';

/**
 * Quick Links configuration.
 * Add or remove external links here — no other source files need to change.
 *
 * Fields per entry:
 *   id          – unique kebab-case identifier
 *   name        – display name shown in sidebar and dashboard
 *   description – short description shown on the dashboard card
 *   url         – external URL (opens in new tab)
 *   icon        – Lucide icon name (https://lucide.dev/icons)
 *   category    – optional grouping label for dashboard display
 */
const rawConfig: QuickLinksConfig = {
  version: '1.0',
  links: [
    {
      id: 'grand-lodge-website',
      name: 'Grand Lodge of Texas Website',
      description: 'Browse the Grand Lodge of Texas website.',
      url: 'https://grandlodgeoftexas.org',
      icon: 'Landmark',
      category: 'Grand Lodge Tools',
    },
    {
      id: 'member-portal',
      name: 'Grandview Member Portal',
      description: 'Membership and Lodge Management system.',
      url: 'https://tx.grandview.systems',
      icon: 'Contact',
      category: 'Grand Lodge Tools',
    },
  ],
};

/**
 * Parsed and validated quick link entries.
 * Invalid entries are excluded and a warning is logged for each one.
 * Import this wherever the quick links list is needed (sidebar, dashboard).
 */
export const quickLinks = parseQuickLinks(rawConfig);
